// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {

	/*fade in out header*/    
	let fadeOptions = {
		"duration": 0,
		"delay": 0
	};

	$w("#anchor1").onViewportEnter(anchor1_viewportEnter);
	$w("#anchor1").onViewportLeave(anchor1_viewportLeave);


	function anchor1_viewportEnter(event) {
		$w('#BlackHeader').hide("fade", fadeOptions);
		$w('#TransparentHeader').show("fade", fadeOptions);
		//Add your code for this event here: 
	}

	function anchor1_viewportLeave(event) {
		$w('#BlackHeader').show("fade", fadeOptions);
		$w('#TransparentHeader').hide("fade", fadeOptions);
		//Add your code for this event here: 
	}
	/* end fade in out header*/    

});






